<template>
  <v-sheet class="slider-wrapper" elevation="6">
    <v-slide-group v-model="model" class="mt-2" show-arrows center-active>
      <v-slide-item
        v-for="item in visibleQrTypes"
        :key="item.value"
        :value="item.value"
        class="mt-6 mx-1"
        v-slot="{ active, toggle }"
      >
        <v-card
          class="text-center transition-card"
          :class="{
            'is-active': active,
            'is-inactive': model !== null && !active,
          }"
          width="100"
          height="70"
          outlined
          flat
          :style="{
            background: `linear-gradient(to bottom left, ${item.colors[0]}, ${item.colors[1]}, ${item.colors[2]})`,
          }"
          :ripple="false"
          elevation="6"
          @click="handleSelection(item, toggle)"
        >
          <v-icon
            v-if="active"
            color="success"
            class="selected-check-icon"
            size="24"
          >
            mdi-check-circle
          </v-icon>

          <div class="main-circle">
            <v-avatar
              size="40"
              :style="{
                background: `linear-gradient(to bottom right, white, ${item.colors[2]})`,
              }"
              elevation="6"
            >
              <v-icon :color="item.colors[0]" size="20">
                mdi-{{ item.icon }}
              </v-icon>
            </v-avatar>
          </div>

          <v-card-text
            class="text-box mt-3"
            style="height: 52%; justify-content: center"
          >
            <div
              class="text-title"
              style="justify-content: center; padding-top: 10%"
              :style="{
                color: `${item.colors[0]}`,
              }"
            >
              {{ item.name }}
            </div>
          </v-card-text>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
export default {
  name: "QrTypeCard",
  props: {
    value: {
      type: String,
      default: null,
    },
    perpurchase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      QrTypes: [],
      model: this.value || null,
    };
  },
  computed: {
    visibleQrTypes() {
      if (!this.perpurchase) return this.QrTypes;
      return this.QrTypes.filter(
        (item) =>
          item.status !== "deactive" &&
          !["qrlink", "clickyarseo"].includes(item.value)
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.model = newVal || null;
      },
    },
    model(newVal) {
      if (newVal !== this.value) {
        this.$emit("input", newVal);
        this.$emit("selectQr", newVal);
      }
    },
  },
  mounted() {
    this.QrTypes = this.getQrTypes();
    if (this.value) {
      this.model = this.value;
    }
  },
  methods: {
    handleSelection(item, toggle) {
      toggle();
      this.$emit("input", item.value);
      this.$emit("selectQr", item.value);
    },
    getQrTypes() {
      return [
        {
          value: "visitCard",
          name: "کارت ویزیت",
          icon: "card-account-details",
          colors: ["#B5A93F", "#7986CB", "#C5CAE9"],
          pro: false,
          status: "active",
        },
        {
          value: "visitcardpro",
          name: "کارت ویزیت پرو",
          icon: "card-account-details",
          colors: ["#1A237E", "#3949AB", "#C5CAE9"],
          pro: true,
          status: "active",
        },
        {
          value: "goldLabel",
          name: "لیبل طلایی",
          icon: "gold",
          colors: ["#FFB300", "#FFCA28", "#FFF8E1"],
          pro: false,
          status: "active",
        },
        {
          value: "appointment",
          name: "نوبت‌دهی",
          icon: "calendar-month",
          colors: ["#4CAF50", "#81C784", "#C8E6C9"],
          pro: false,
          status: "active",
        },
        {
          value: "Business",
          name: "کسب و کار",
          icon: "store",
          colors: ["#FF9800", "#FFB300", "#FFE082"],
          pro: false,
          status: "active",
        },
        {
          value: "Commericial",
          name: "سایت مجتمع تجاری/اداری",
          icon: "office-building-outline",
          colors: ["#607D8B", "#90A4AE", "#CFD8DC"],
          pro: false,
          status: "active",
        },
        {
          value: "qrlink",
          name: "لینک",
          icon: "link-variant-plus",
          colors: ["#0288D1", "#03A9F4", "#B3E5FC"],
          pro: false,
          status: "deactive",
        },
        {
          value: "clickyarseo",
          name: "سئو کلیک یار",
          icon: "bullseye-arrow",
          colors: ["#00B0FF", "#40C4FF", "#B3E5FC"],
          pro: false,
          status: "deactive",
        },
        {
          value: "application",
          name: "ارائه اپلیکیشن",
          icon: "application-braces-outline",
          colors: ["#C2185B", "#E91E63", "#F8BBD0"],
          pro: false,
          status: "active",
        },
        {
          value: "labelproduct",
          name: "لیبل محصول",
          icon: "tag-multiple",
          colors: ["#009688", "#4DB6AC", "#B2DFDB"],
          pro: false,
          status: "active",
        },
        {
          value: "bShop",
          name: "صفحه فروشگاهی",
          icon: "storefront",
          colors: ["#F44336", "#E57373", "#FFCDD2"],
          pro: false,
          status: "active",
        },
        {
          value: "SocialMedia",
          name: "شبکه های اجتماعی",
          icon: "comment-account",
          colors: ["#9C27B0", "#BA68C8", "#E1BEE7"],
          pro: false,
          status: "active",
        },
        {
          value: "VideoGallery",
          name: "گالری ویدئو",
          icon: "video",
          colors: ["#D81B60", "#F06292", "#F8BBD0"],
          pro: false,
          status: "active",
        },
        {
          value: "voiceGallery",
          name: "گالری صوتی",
          icon: "folder-play",
          colors: ["#512DA8", "#673AB7", "#D1C4E9"],
          pro: false,
          status: "active",
        },
        {
          value: "voiceGalleryPro",
          name: "گالری صوتی پرو",
          icon: "folder-play-outline",
          colors: ["#303F9F", "#3F51B5", "#C5CAE9"],
          pro: false,
          status: "active",
        },
        {
          value: "PhotoGallery",
          name: "گالری عکس",
          icon: "image",
          colors: ["#FFC107", "#FFD54F", "#FFECB3"],
          pro: false,
          status: "active",
        },
        {
          name: "قاب خاطره ها",
          value: "gift",
          route: "qr.gift",
          colors: ["#8A151B", "#E3242B", "#99592A"],
          icon: "hand-heart-outline",
          pro: false,
          status: "active",
        },
        {
          value: "consultationQr",
          name: "فرم درخواست",
          icon: "list-box-outline",
          colors: ["#00796B", "#26A69A", "#B2DFDB"],
          pro: false,
          status: "active",
        },
        {
          value: "feedbackGallery",
          name: "گالری بازخورد/ فیدبک",
          icon: "comment-quote",
          colors: ["#E64A19", "#FF5722", "#FFCCBC"],
          pro: false,
          status: "active",
        },
        {
          value: "singleProduct",
          name: "معرفی محصول",
          icon: "package",
          colors: ["#795548", "#A1887F", "#D7CCC8"],
          pro: false,
          status: "active",
        },
        {
          value: "productpro",
          name: "معرفی محصول پرو",
          icon: "professional-hexagon",
          colors: ["#1976D2", "#42A5F5", "#BBDEFB"],
          pro: false,
          status: "active",
        },
        {
          value: "menu",
          name: "منو",
          icon: "book-open-outline",
          colors: ["#00BCD4", "#4DD0E1", "#B2EBF2"],
          pro: false,
          status: "active",
        },
        {
          value: "wheel",
          name: "گردونه شانس",
          icon: "clover-outline",
          colors: ["#388E3C", "#4CAF50", "#C8E6C9"],
          pro: false,
          status: "active",
        },
        {
          value: "catalog",
          name: "کاتالوگ",
          icon: "notebook",
          colors: ["#5D4037", "#8D6E63", "#D7CCC8"],
          pro: false,
          status: "active",
        },
        {
          value: "multicard",
          name: "مولتی کارت",
          icon: "card-multiple",
          colors: ["#455A64", "#78909C", "#CFD8DC"],
          pro: false,
          status: "active",
        },
        {
          value: "pdfGallery",
          name: "گالری پی دی اف (PDF)",
          icon: "file-pdf-box",
          colors: ["#D32F2F", "#EF5350", "#FFCDD2"],
          pro: false,
          status: "active",
        },
        {
          value: "text",
          name: "متن",
          icon: "card-text-outline",
          colors: ["#616161", "#9E9E9E", "#E0E0E0"],
          pro: false,
          status: "deactive",
        },
        {
          value: "instagram",
          name: "اینستاگرام",
          icon: "instagram",
          colors: ["#E4405F", "#F77737", "#FCAF45"],
          pro: false,
          status: "deactive",
        },
        {
          value: "insurance",
          name: "بیمه آنلاین",
          icon: "shield-account-outline",
          colors: ["#2196F3", "#64B5F6", "#BBDEFB"],
          pro: false,
          status: "deactive",
        },
          {
          name: "بله",
          value: "",
          route: "qr.bale", 
          colors: ["#4CD6AE", "#3D9196", "#324A7D"],
          image: "/media/socialnetwork/icon/bale.webp", 
          status: "deactive",

        },
        {
          name: "روبیکا",
          value: "",
          route: "qr.robika", 
          colors: ["#7c25c7", "#E45153", "#F4AA32"],
          image: "/media/socialnetwork/icon/robika.webp", 
          status: "deactive",

        },
        {
          name: "ایتا",
          value: "",
          route: "qr.eitaa", 
          colors: ["#B84C24", "#fa8945", "#F05E28"],
          image: "/media/socialnetwork/icon/eitaa.webp",
          status: "deactive",

        },
        {
          value: "bankcard",
          name: "کیوکارت",
          icon: "credit-card-outline", // یا mdi-bank-outline
          colors: ["#1A237E", "#303F9F", "#E8EAF6"],
          pro: false,
          status: "deactive",
        },
        {
          value:'attendanceqr',
          name: "حضور و غیاب",
          icon: "account-check",
          colors: ["#0284C7", "#10B981", "#D1FAE5"],
          pro: false,
          status: 'deactive',
        },
      ];
    },
  },
};
</script>

<style scoped>
.slider-wrapper {
  width: 100%;
}

.v-slide-group {
  width: 100%;
  overflow: hidden;
}

.main-circle {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.text-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #f5f5f5;
  border-radius: 4px;
  padding: 4px 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  width: 90%;
  text-align: center;
}

.text-title {
  font-size: 10px;
  font-weight: bold;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.disabled-item {
  opacity: 0.5 !important;
  pointer-events: none !important;
}

.v-card {
  position: relative;
  transition: transform 0.2s ease-out;
}

.v-card:hover:not(.disabled-item) {
  transform: translateY(-2px);
  box-shadow: 0 5px 9px rgba(0, 0, 0, 0.2);
}
.transition-card {
  transition: transform 0.3s ease-out, opacity 0.3s ease-out,
    box-shadow 0.3s ease-out, filter 0.3s ease-out !important;
  will-change: transform, opacity, filter;
}

.is-active {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3) !important;
  border: 2px solid #4caf50 !important;
  z-index: 2;
}

.is-inactive {
  opacity: 0.5 !important;
  transform: scale(0.9);
  filter: grayscale(40%);
}

.selected-check-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: white;
  border-radius: 50%;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
